import { Element, Event, EventEmitter,Component, h, Prop } from '@stencil/core';
import { isUserLoggedIn } from '../../utils/is_user_logged_in';
import { isBrowser } from '../../constants/constants';
import arrow from '../../assets/header/next_arrow.svg';
import account from '../../assets/header/account.svg';
import cart from '../../assets/header/cart_grey.svg';
import locationPin from '../../assets/header/stores_pin.svg';
import redPhone from '../../assets/phone_red.svg';
import iconFundraising from '../../assets/icons/fundraising.svg';
import iconGroups from '../../assets/icons/group-ordering.svg';
import iconStores from '../../assets/icons/online-stores.svg';

@Component({
  tag: 'ci-mobile-subnav',
  styleUrl: 'ci-mobile-subnav.scss',
  shadow: true,
})
export class ciMobileSubnav {
  @Element() $el: HTMLElement;
  @Prop() serviceNumber: string;
  @Prop() visible: boolean
  @Prop() visibleDrawer: boolean;
  @Event() closeDrawer: EventEmitter<void>;

  toggleSubNav(menuId: string, arrowId: string) {
    const menu = this.$el.shadowRoot.querySelector('#' + menuId);
    const arrow = this.$el.shadowRoot.querySelector('#' + arrowId);

    menu.classList.toggle('ciMobileSubnav-accordion-menu-wrapper--active');
    arrow.classList.toggle('ciMobileSubnav-accordion-arrow--active');
  }

  render() {
    return (
      <div class="ciMobileSubnav"
        style={{
          visibility: this.visible ? 'visible' : 'hidden'
        }}
      >
        <ci-drawer open={this.visibleDrawer} onClose={() => {
          this.closeDrawer.emit()
        }} >
          <ul class="ciMobileSubnav-mainMenu">
            <li class="ciMobileSubnav-mainMenu-listItem">
              <a class="ciMobileSubnav-mainMenu-link" onClick={() => this.toggleSubNav('cdMobileSubNav-productsMenu', 'rotate-arrow-product')}>
                Products
                <img class="ciMobileSubnav-accordion-arrow" id="rotate-arrow-product" src={arrow} alt="arrow icon" />
              </a>
            </li>
            <div class="ciMobileSubnav-accordion-menu-wrapper" id="cdMobileSubNav-productsMenu">
              <ul class="ciMobileSubnav-accordion-menu" id="products">
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/products/t-shirts/4`}
                    class="ciMobileSubnav-accordion-menu-link js-ciHeader-track"
                    data-section="products"
                    data-link="t-shirts"
                  >
                    <span>T-shirts</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/products/sweatshirts/hoodies/71`}
                    class="ciMobileSubnav-accordion-menu-link js-ciHeader-track"
                    data-section="products"
                    data-link="hoodies"
                  >
                    <span>Hoodies</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/products/sweatshirts/13`}
                    class="ciMobileSubnav-accordion-menu-link js-ciHeader-track"
                    data-section="products"
                    data-link="sweatshirts"
                  >
                    <span>Sweatshirts</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/products/polo-shirts/148`}
                    class="ciMobileSubnav-accordion-menu-link js-ciHeader-track"
                    data-section="products"
                    data-link="polo shirts"
                  >
                    <span>Polo Shirts</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a href={`${process.env.CI_HOSTNAME}/products/hats/1`} class="ciMobileSubnav-accordion-menu-link js-ciHeader-track" data-section="products" data-link="hats">
                    <span>Hats</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/products/promotional-products/218`}
                    class="ciMobileSubnav-accordion-menu-link js-ciHeader-track"
                    data-section="products"
                    data-link="promotional products"
                  >
                    <span>Promotional Products</span>
                  </a>
                </li>
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/products/`}
                    class="ciMobileSubnav-accordion-menu-link js-ciHeader-track"
                    data-section="products"
                    data-link="view all categories"
                  >
                    <span>View All Categories</span>
                  </a>
                </li>
              </ul>
            </div>
            <li class="ciMobileSubnav-mainMenu-listItem">
              <a href={`${process.env.CI_HOSTNAME}/lab`} class="ciMobileSubnav-mainMenu-link js-ciHeader-track" data-section="design lab" data-link="design lab">
                Design Lab
              </a>
            </li>
            <li class="ciMobileSubnav-mainMenu-listItem">
              <a href={`${process.env.CI_HOSTNAME}/inspiration`} class="ciMobileSubnav-mainMenu-link js-ciHeader-track" data-section="templates" data-link="templates">
                Templates
              </a>
            </li>
            <li class="ciMobileSubnav-mainMenu-listItem">
              <a class="ciMobileSubnav-mainMenu-link"
              onClick={() => this.toggleSubNav('cdMobileSubNav-solutionsMenu', 'rotate-arrow-solutions')}>
                Solutions
                <img class="ciMobileSubnav-accordion-arrow" id="rotate-arrow-solutions" src={arrow} alt="arrow icon" />
              </a>
            </li>
            <div class="ciMobileSubnav-accordion-menu-wrapper" id="cdMobileSubNav-solutionsMenu">
              <ul class="ciMobileSubnav-accordion-menu ciMobileSubnav-accordion-menu--solutions" id="solutions">
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/ink/group-order-form`}
                    rel="nofollow"
                    class="ciMobileSubnav-accordion-menu-linkSolutions ciMobileSubnav-accordion-menu-linkSolutionsIcons js-ciHeader-track"
                    data-section="solutions"
                    data-link="Group Order"
                  >
                    <span class="ciMobileSubnav-accordion-menu-linkSolutionsIcons-icon">
                      <img src={iconGroups} alt="group icon" />
                    </span>
                    <span class="ciMobileSubnav-accordion-menu-linkSolutionsIcons-text">
                      <span class="ciMobileSubnav-accordion-menu-linkSolutions-title">Group Ordering</span>
                      <span class="ciMobileSubnav-accordion-menu-linkSolutions-subtitle">Easily collect sizes, addresses, and payments from your group.</span>
                    </span>
                  </a>
                </li>
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/fundraising`}
                    class="ciMobileSubnav-accordion-menu-linkSolutions ciMobileSubnav-accordion-menu-linkSolutionsIcons js-ciHeader-track"
                    data-section="solutions"
                    data-link="Fundraising"
                  >
                    <span class="ciMobileSubnav-accordion-menu-linkSolutionsIcons-icon">
                      <img src={iconFundraising} alt="fundraising icon" />
                    </span>
                    <span class="ciMobileSubnav-accordion-menu-linkSolutionsIcons-text">
                      <span class="ciMobileSubnav-accordion-menu-linkSolutions-title">Fundraising</span>
                      <span class="ciMobileSubnav-accordion-menu-linkSolutions-subtitle">Raise money and awareness for anything you care about.</span>
                    </span>
                  </a>
                </li>
                <li class="ciMobileSubnav-accordion-menu-listItem">
                  <a
                    href={`${process.env.CI_HOSTNAME}/onlinestores`}
                    rel="nofollow"
                    class="ciMobileSubnav-accordion-menu-linkSolutions ciMobileSubnav-accordion-menu-linkSolutionsIcons js-ciHeader-track"
                    data-section="solutions"
                    data-link="Online Stores"
                  >
                    <span class="ciMobileSubnav-accordion-menu-linkSolutionsIcons-icon">
                      <img src={iconStores} alt="online stores icon" />
                    </span>
                    <span class="ciMobileSubnav-accordion-menu-linkSolutionsIcons-text">
                      <span class="ciMobileSubnav-accordion-menu-linkSolutions-title">Online Stores</span>
                      <span class="ciMobileSubnav-accordion-menu-linkSolutions-subtitle">Create a branded storefront to sell merchandise to your community.</span>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </ul>
          <ul class="ciMobileSubnav-secondaryMenu">
            <li class="ciMobileSubnav-secondaryMenu-listItem">
              <a class="ciMobileSubnav-secondaryMenu-link js-ciHeader-track" href={`${process.env.CI_HOSTNAME}/profiles/retrieve`} data-section="my account" data-link="my account">
                <img src={account} alt="account icon" />
                {isBrowser && (isUserLoggedIn() ? 'My Account' : 'Sign In')}
              </a>
            </li>
            <li class="ciMobileSubnav-secondaryMenu-listItem">
              <a class="ciMobileSubnav-secondaryMenu-link js-ciHeader-track" href={`${process.env.CI_HOSTNAME}/checkout/summary`} data-section="my cart" data-link="my cart">
                <img src={cart} alt="cart icon" />
                My Cart
              </a>
            </li>
            <li class="ciMobileSubnav-secondaryMenu-listItem">
              <a class="ciMobileSubnav-secondaryMenu-link" href="https://locations.customink.com/">
                <img src={locationPin} alt="stores pin icon" />
                Visit a Store
              </a>
            </li>
          </ul>
          <div class="ciMobileSubnav-chat">
            <a href={`tel:${this.serviceNumber}`} class="tertiary-secondary-button">
              <img class="ciMobileSubnav-headset" src={redPhone} alt="headset icon" />
              <span class="ciMobileSubnav-real-person">Talk to a Real Person</span>
            </a>
          </div>
        </ci-drawer>
      </div>
    );
  }
}
